// @ts-nocheck

import Vue from 'vue'
import { ApiService } from '@/services'

import { SwayOffer } from '@/models/SwayOffer'

interface OfferState {
  loading: boolean
  swayOfferMutationLoading: boolean
  swayOffers: SwayOffer[]
}

const state: OfferState = {
  loading: false,
  swayOfferMutationLoading: false,
  swayOffers: [],
}

const getters = {
  loading: () => state.loading,
  swayOfferMutationLoading: () => state.swayOfferMutationLoading,
  swayOffers: () => state.swayOffers,
}

const actions = {
  async createSwayOffer({ commit }, { swayOfferBase }: SwayOfferBase) {
    await ApiService.post('swayOffer', { ...swayOfferBase }).then((response) => {
      commit('refresh', [...state.swayOffers, response.data])
    })
  },
  updateSwayOffer({ commit, dispatch }, { swayOffer }: SwayOffer) {
    commit('swayOfferMutationLoading', true)
    dispatch('app/setAppProgressBarVisibility', { visible: true }, { root: true })

    ApiService.put(`swayOffer/${swayOffer.id}`, { ...swayOffer }).then((response) => {
      commit('updateSwayOffer', { ...response.data })
      commit('swayOfferMutationLoading', false)
      dispatch('app/setAppProgressBarVisibility', { visible: false }, { root: true })

      Vue.prototype.$toast.success('Offer Updated!')
    })
  },
  refresh({ commit }) {
    commit('loading', true)

    ApiService.get('swayOffer').then((response) => {
      commit('refresh', response.data)
      commit('loading', false)
    })
  },
}

const mutations = {
  loading(state: OfferState, payload: boolean) {
    state.loading = payload
  },
  swayOfferMutationLoading(state: OfferState, payload: boolean) {
    state.swayOfferMutationLoading = payload
  },
  updateSwayOffer(state: OfferState, payload: SwayOffer) {
    Vue.set(
      state.swayOffers,
      state.swayOffers.findIndex((swayOffer) => swayOffer.id === payload.id),
      payload
    )
  },
  refresh(state: OfferState, payload: [SwayOffer[]]) {
    state.swayOffers = payload
  },
}

export const swayoffer = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
